<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>RESEARCH</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Research</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<!-- BLOG DETAILS
        ================================================== -->
<section class="blogs">
    <div class="container">
        <div class="row mt-n2-9">

            <!--  start blog left-->
            <div class="col-md-12 col-lg-8 mt-2-9">
                <div class="posts-wrapper">
                    <!--  start post-->

                    <div class="post-content">
                        <div class="row mb-1-6 mb-xl-1-9">
                            <div class="col-md-12">
                                <blockquote>
                                    <strong><b>Office of the Dean Research (Research and Development)</b></strong>
                                    <p class="display-30 display-md-29 display-xl-28 alt-font font-weight-500 text-color">
                                        It is with great pleasure and enthusiasm that I extend a warm welcome to all
                                        students, faculty members, staff, and visitors to our esteemed institution's
                                        website.
                                    </p>
                                    <p>I encourage you to explore our website to learn more about our academic programs,
                                        research endeavors, and the vibrant campus life at Arni School of Pharmacy, Arni
                                        University, Kathgarh, Indora H.P. Whether you are a prospective student, a
                                        current member of our academic community, or a visitor seeking information, our
                                        website is designed to be a valuable resource for you.
                                    </p>
                                    <p>Thank you for choosing Arni University as your partner in education and
                                        professional development. We look forward to embarking on this journey of
                                        knowledge, growth, and success together.
                                    </p>
                                    <cite class="font-weight-800 text-primary">Prof. (Dr.) Neeraj Bhandari (Dean R&D)
                                    </cite>
                                </blockquote>

                            </div>
                        </div>
                    </div>
                    <!--  end post-->
                </div>
            </div>
            <!--  end blog left-->

            <!--  start blog right-->
            <div class="col-lg-4 mt-2-9">
                <div class="ps-lg-1-6 ps-xl-1-9">

                    <article class="blog-style1 position-relative d-block mb-0">
                        <div class="img-holder position-relative d-block">
                            <div class="image-hover">
                                <img src="assets/img/chancellor/7.jpeg" alt="...">
                            </div>
                        </div>
                        <div class="text-holder">
                            <div class="category-box">
                                <a href="#!">Dean Research</a>
                            </div>
                            <h3 class="display-25 font-weight-700 mb-3"><a href="blog-details.html">Prof. (Dr.) Neeraj
                                Bhandari (Dean R&D)</a></h3>
                            <div><p>As our University’s Dean for Research, I would like to welcome you to the University
                                Research website to learn about our efforts in research.</p></div>
                        </div>
                    </article>

                </div>
            </div>
            <!--  end blog right-->

        </div>
    </div>
</section>


<!-- BLOG DETAILS
        ================================================== -->
<section class="blogs">
    <div class="container">
        <div class="row">
            <!--  start blog left-->
            <div class="col-md-12 col-lg-12">
                <div class="posts-wrapper">
                    <!--  start post-->

                    <div class="post-content">
                        <div class="row mb-1-6 mb-xl-1-9">
                            <div class="col-md-12">
                                <h5>Announcements</h5>

                                <marquee behavior="scroll" direction="up" onmouseover="this.stop();"
                                         onmouseout="this.start();" style="height: 300px">
                                    <div class="single-item bg-secondary border-primary p-3 text-white">
                                        <div class="single-item-text">
                                            <h4><a href="assets/pdf/PHDSyllabusforentrance.pdf"
                                                   target="_blank">Syllabus</a></h4>
                                            <hr>
                                            <p>PhD Entrance Examination Syllabus- 2021-22</p>

                                        </div>
                                    </div>
                                </marquee>

                            </div>
                        </div>
                    </div>
                    <!--  end post-->
                </div>
            </div>
            <!--  end blog left-->
        </div>
    </div>
</section>
